export const successMsgs = {
  addedToWhitelist1: ' تمت إضافة',
  addedToWhitelist2: ' بنجاح إلي قائمة المؤهلين',
  removedFromWhitelist1: 'تمت إزالة ',
  removedFromWhitelist2: 'بنجاح من قائمة المؤهلين',
  bulkDriversAddedToWhitelist:
    'تم إضافة السائقين المختارين بنجاح إلي قائمة المؤهلين',
  bulkDriversRemovedFromWhitelist:
    "تم إزالة السائقين المختارين بنجاح من قائمة المؤهلين",
  bulkDriversUpdateShortly: "سيتم تعديل قائمة السائقين في خلال ثوانى",
  driverStatusUpdated: "تم تعديل حالة السائق بنجاح",
  offerCreated: "تم إنشاء العرض بنجاح",
  offerEdited: "تم تعديل العرض بنجاح",
  offerDeleted: "تم حذف العرض بنجاح",
  offerPublished: "تم نشر العرض بنجاح",
  offerUnpublished: "تم إلغاء نشر العرض بنجاح",
  offerUpdated: "تم تعديل العرض بنجاح",
  tripEnded: "تم إنهاء الرحلة بنجاح",
  animationCreated: "تم إنشاء الرسوم المتحركة بنجاح",
  animationDeleted: "تم حذف الرسوم المتحركة بنجاح",
  animationUpdated: "تم تحديث الرسوم المتحركة بنجاح",
  serviceOfferMarked: "تم تعليم العرض كعرض خدمة بنجاح",
  serviceOfferRemoved: "تمت إزالة علامة عرض الخدمة بنجاح",
  challengeCreated: "تم إنشاء التحدي بنجاح",
  challengeEdited: "تم تعديل التحدي بنجاح",
  challengeSavedAsDraft: "تم حفظ التحدي كمسودة بنجاح",
  challengePublished: "تم نشر التحدي بنجاح",
  challengeUnpublished: "تم إلغاء نشر التحدي بنجاح",
  challengeDuplicated: "تم تكرار التحدي بنجاح",
  challengeDraftDeleted: "تم حذف مسودة التحدي بنجاح",
  userFlagged: "تم وضع علامة احتيال على المستخدم بنجاح",
  userUnflagged: "تمت إزالة علامة الاحتيال بنجاح",
};
